!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("mini-create-react-context"), require("prop-types"), require("react-router-dom")) : "function" == typeof define && define.amd ? define(["exports", "react", "mini-create-react-context", "prop-types", "react-router-dom"], t) : t(e.CacheRoute = {}, e.React, e.createContext, e.PropTypes, e.reactRouterDom);
}(this, function (e, w, t, n, i) {
  "use strict";

  var g = "default" in w ? w.default : w;
  t = t && t.hasOwnProperty("default") ? t.default : t, n = n && n.hasOwnProperty("default") ? n.default : n;

  function o(e) {
    return void 0 === e;
  }

  function u(e) {
    return null === e;
  }

  function C(e) {
    return "number" == typeof e && !s(e);
  }

  function l(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  var a = function a(e) {
    return "function" == typeof e;
  },
      h = function h(e) {
    return "string" == typeof e;
  },
      r = function r(e) {
    return !(o(e) || u(e));
  },
      c = function c(e) {
    return e instanceof Array;
  },
      s = function s(e) {
    return e != e;
  },
      f = function f(e) {
    var t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : [],
        n = arguments[2];

    try {
      C(t) && (t = String(t));
      var r = (h(t) ? t.split(".") : t).reduce(function (e, t) {
        return e[t];
      }, e);
      return o(r) ? n : r;
    } catch (e) {
      return n;
    }
  },
      O = function O(e) {
    for (var t = arguments.length, n = Array(2 < t ? t - 2 : 0), r = 2; r < t; r++) {
      n[r - 2] = arguments[r];
    }

    var o = h(o = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : []) ? o.split(".") : o,
        c = f(e, o),
        o = f(e, o.slice(0, -1));
    return a(c) ? c.call.apply(c, [o].concat(n)) : c;
  },
      d = function d() {
    for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
      t[n] = arguments[n];
    }

    return t.reduce(function (e, t) {
      return o(e) ? O(t) : O(e);
    }, void 0);
  },
      p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      m = function m(e, t, n) {
    return t && y(e.prototype, t), n && y(e, n), e;
  };

  function y(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function v(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function _(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
  }

  function j(e, t) {
    var n,
        r = {};

    for (n in e) {
      0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    }

    return r;
  }

  function b(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
  }

  function E(e) {
    return e.reduce(function (e, t) {
      return [].concat(T(e), T(c(t) ? E(t) : [t]));
    }, []);
  }

  function P(e) {
    var t,
        n = [];

    for (t in e) {
      n.push(e[t]);
    }

    return n;
  }

  var R = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n,
          r = arguments[t];

      for (n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }

    return e;
  },
      S = function S(e, t) {
    if (Array.isArray(e)) return e;
    if (Symbol.iterator in Object(e)) return function (e, t) {
      var n = [],
          r = !0,
          o = !1,
          c = void 0;

      try {
        for (var a, i = e[Symbol.iterator](); !(r = (a = i.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, c = e;
      } finally {
        try {
          !r && i.return && i.return();
        } finally {
          if (o) throw c;
        }
      }

      return n;
    }(e, t);
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  },
      T = function T(e) {
    if (Array.isArray(e)) {
      for (var t = 0, n = Array(e.length); t < e.length; t++) {
        n[t] = e[t];
      }

      return n;
    }

    return Array.from(e);
  },
      L = function () {
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    if ("undefined" != typeof global) return global;
    throw new Error("unable to locate global object");
  }(),
      M = "object" === ("undefined" == typeof global ? "undefined" : p(global)) && global && global.Math === Math && global.Array === Array ? global : L,
      N = f(M, "document.body"),
      k = f(M, "document.scrollingElement", f(M, "document.documentElement", {}));

  function A() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {};
    return !!r(e) && (e.scrollWidth > e.clientWidth || e.scrollHeight > e.clientHeight);
  }

  function x(e) {
    return a(f(M, "document.getElementById")) ? [].concat(T(d(O(e, "querySelectorAll", "*"), [])), [e]).filter(A) : [];
  }

  function D() {
    return Object.entries(H).filter(function (e) {
      e = S(e, 2)[1];
      return e instanceof $ ? e.state.cached : Object.values(e).some(function (e) {
        return e.state.cached;
      });
    });
  }

  function q() {
    return R({}, H);
  }

  function F(e, t) {
    H[e] = t;
  }

  function K(e) {
    delete H[e];
  }

  function U(e) {
    return O(e, "reset");
  }

  function B(e) {
    (e = f(H, [e])) && (e instanceof $ ? U(e) : Object.values(e).forEach(U));
  }

  function z(e) {
    return O(e, "refresh");
  }

  var H = {},
      W = t(),
      V = W.Provider;
  W.Consumer;

  function I(t, n) {
    var r,
        e = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : [];
    a(w.useContext) && (r = w.useContext(W), w.useEffect(function () {
      var e = O(r, "on", t, n);
      return function () {
        return O(e);
      };
    }, e));
  }

  function X(e, t) {
    var n = e.match,
        r = void 0 === (r = e.when) ? "forward" : r;
    if (Z(n) || (n = null), !t.cached && n) return {
      cached: !0,
      matched: !0
    };

    if (t.matched && !n) {
      var o = f(e, "history.action"),
          c = !1;
      if (a(r)) c = !r(e);else switch (r) {
        case "always":
          break;

        case "back":
          ["PUSH", "REPLACE"].includes(o) && (c = !0);
          break;

        default:
          "POP" === o && (c = !0);
      }
      if (c) return {
        cached: !1,
        matched: !1
      };
    }

    return {
      matched: !!n
    };
  }

  var G = I.bind(null, "didCache"),
      J = I.bind(null, "didRecover"),
      Q = r(g.forwardRef),
      Y = "__isComputedUnmatch",
      Z = function Z(e) {
    return r(e) && !0 !== f(e, Y);
  },
      $ = (le = w.Component, _(ee, le), m(ee, [{
    key: "componentDidUpdate",
    value: function value(e, t) {
      if (t.cached && this.state.cached) return !0 === t.matched && !1 === this.state.matched ? (this.props.unmount && this.ejectDOM(), this.__cacheUpdateTime = Date.now(), P(this.cacheLifecycles.__didCacheListener).forEach(function (e) {
        O(e);
      }), O(this, "cacheLifecycles.__listener.didCache")) : !1 === t.matched && !0 === this.state.matched ? (this.props.saveScrollPosition && O(this.__revertScrollPos), this.__cacheUpdateTime = Date.now(), P(this.cacheLifecycles.__didRecoverListener).forEach(function (e) {
        O(e);
      }), O(this, "cacheLifecycles.__listener.didRecover")) : void 0;
    }
  }, {
    key: "shouldComponentUpdate",
    value: function value(e, t) {
      var n,
          r = !1 === this.state.matched && !0 === t.matched,
          o = !0 === this.state.cached && !1 === t.cached,
          t = this.state.matched || t.matched || this.state.cached !== t.cached;
      return t && ((this.props.unmount && o || r) && this.injectDOM(), o || r || !this.props.saveScrollPosition || (this.__revertScrollPos = (r = this.props.unmount ? this.wrapper : void 0, n = [].concat(T(new Set([].concat(T(E((c(r) ? r : [r]).map(x))), T([k, N].filter(A)))))).map(function (e) {
        return [e, {
          x: e.scrollLeft,
          y: e.scrollTop
        }];
      }), function () {
        n.forEach(function (e) {
          var t = S(e, 2),
              n = t[0],
              e = t[1],
              t = e.x,
              e = e.y;
          n.scrollLeft = t, n.scrollTop = e;
        });
      }))), t;
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      var e = this.props,
          t = e.unmount,
          n = e.pathname,
          r = e.multiple,
          e = O(this.props, "cacheKey", this.props);
      r ? (delete (r = R({}, q()[e]))[n], 0 === Object.keys(r).length ? K(e) : F(e, r)) : K(e), t && this.injectDOM();
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
          e = this.state,
          n = e.matched,
          r = e.cached,
          o = e.key,
          c = this.props,
          a = c.className,
          e = void 0 === a ? "" : a,
          a = c.behavior,
          c = c.children,
          a = d(O(a, void 0, !n), {}),
          n = a.className,
          n = void 0 === n ? "" : n,
          a = j(a, ["className"]),
          n = O(e + " " + n, "trim");
      return r ? g.createElement("div", R({
        key: o,
        className: "" !== n ? n : void 0
      }, a, {
        ref: function ref(e) {
          t.wrapper = e;
        }
      }), g.createElement(V, {
        value: this.cacheLifecycles
      }, O(c, void 0, this.cacheLifecycles))) : null;
    }
  }]), ee);

  function ee(e) {
    l(this, ee);

    for (var t = arguments.length, n = Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) {
      n[r - 1] = arguments[r];
    }

    var o,
        c,
        a = b(this, (o = ee.__proto__ || Object.getPrototypeOf(ee)).call.apply(o, [this, e].concat(n)));
    return a.cacheLifecycles = {
      __listener: {},
      __didCacheListener: {},
      __didRecoverListener: {},
      on: function on(e, t) {
        var n = Math.random(),
            r = "__" + e + "Listener";
        return a.cacheLifecycles[r][n] = t, function () {
          delete a.cacheLifecycles[r][n];
        };
      },
      didCache: function didCache(e) {
        a.cacheLifecycles.__listener.didCache = e;
      },
      didRecover: function didRecover(e) {
        a.cacheLifecycles.__listener.didRecover = e;
      }
    }, a.componentWillReceiveProps = Q ? void 0 : function (e) {
      e = X(e, a.state);
      a.setState(e);
    }, a.injectDOM = function () {
      try {
        O(a.__parentNode, "insertBefore", a.wrapper, a.__placeholderNode), O(a.__parentNode, "removeChild", a.__placeholderNode);
      } catch (e) {}
    }, a.ejectDOM = function () {
      try {
        var e = f(a.wrapper, "parentNode");
        a.__parentNode = e, O(a.__parentNode, "insertBefore", a.__placeholderNode, a.wrapper), O(a.__parentNode, "removeChild", a.wrapper);
      } catch (e) {}
    }, a.reset = function () {
      delete a.__revertScrollPos, a.setState({
        cached: !1
      });
    }, a.refresh = function () {
      delete a.__revertScrollPos, a.setState({
        key: Math.random()
      });
    }, a.__cacheCreateTime = Date.now(), a.__cacheUpdateTime = a.__cacheCreateTime, e.cacheKey && (c = O(e.cacheKey, void 0, e), e.multiple ? (o = e.pathname, F(c, R({}, q()[c], v({}, o, a)))) : F(c, a)), "undefined" != typeof document && (c = O(e.cacheKey, void 0, e), a.__placeholderNode = document.createComment(" Route cached " + (c ? 'with cacheKey: "' + c + '" ' : ""))), a.state = X(e, {
      cached: !1,
      matched: !1,
      key: Math.random()
    }), a;
  }

  function te(e) {
    var t = e.freeze,
        e = e.children,
        n = w.useRef({}).current;
    if (t && !n.promise) throw n.promise = new Promise(function (e) {
      n.resolve = e;
    }), n.promise;
    if (t) throw n.promise;
    return n.promise && (n.resolve(), n.promise = void 0), g.createElement(w.Fragment, null, e);
  }

  $.__name = "CacheComponent", $.propsTypes = {
    history: n.object.isRequired,
    match: n.object.isRequired,
    children: n.func.isRequired,
    className: n.string,
    when: n.oneOfType([n.func, n.oneOf(["forward", "back", "always"])]),
    behavior: n.func,
    unmount: n.bool,
    saveScrollPosition: n.bool
  }, $.defaultProps = {
    when: "forward",
    unmount: !1,
    saveScrollPosition: !1,
    behavior: function behavior(e) {
      return e ? {
        style: {
          display: "none"
        }
      } : void 0;
    }
  }, $.getDerivedStateFromProps = Q ? X : void 0;
  var ne = !!w.Suspense,
      re = ne ? function (e) {
    var t = e.freeze,
        n = e.children,
        e = e.placeholder;
    return g.createElement(w.Suspense, {
      fallback: void 0 === e ? null : e
    }, g.createElement(te, {
      freeze: t
    }, n));
  } : function (e) {
    return e.children;
  },
      oe = (t = w.Component, _(ce, t), ce);

  function ce() {
    var e, t;
    l(this, ce);

    for (var n = arguments.length, r = Array(n), o = 0; o < n; o++) {
      r[o] = arguments[o];
    }

    return (e = t = b(this, (e = ce.__proto__ || Object.getPrototypeOf(ce)).call.apply(e, [this].concat(r)))).shouldComponentUpdate = ne ? function () {
      return !0;
    } : function (e) {
      return e.when;
    }, t.render = function () {
      return g.createElement(re, {
        freeze: !t.props.when
      }, O(t.props, "children"));
    }, b(t, e);
  }

  oe.propsTypes = {
    when: n.bool.isRequired
  };
  var ae = r(w.Fragment),
      t = (le = w.Component, _(ie, le), m(ie, [{
    key: "render",
    value: function value() {
      var l = this,
          e = this.props,
          h = e.children,
          s = e.render,
          f = e.component,
          d = e.className,
          p = e.when,
          m = e.behavior,
          y = e.cacheKey,
          v = e.unmount,
          _ = e.saveScrollPosition,
          t = e.computedMatchForCacheRoute,
          b = e.multiple,
          n = j(e, ["children", "render", "component", "className", "when", "behavior", "cacheKey", "unmount", "saveScrollPosition", "computedMatchForCacheRoute", "multiple"]);
      return !g.isValidElement(h) && (e = h, 0 === g.Children.count(e)) || (s = function s() {
        return h;
      }), t && (n.computedMatch = t), C(b = b && !ae ? !1 : b) && (b = function (e, t) {
        var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : Number.MAX_VALUE;
        return e < t ? t : n < e ? n : e;
      }(b, 1)), g.createElement(i.Route, n, function (r) {
        var o = r.match,
            c = r.computedMatch,
            e = r.location,
            t = Z(r.match),
            a = e.pathname,
            i = e.search,
            n = C(b) ? b : 1 / 0,
            u = {
          when: p,
          className: d,
          behavior: m,
          cacheKey: y,
          unmount: v,
          saveScrollPosition: _
        },
            e = function e(t) {
          return g.createElement($, t, function (e) {
            return g.createElement(oe, {
              when: Z(t.match)
            }, function () {
              return Object.assign(t, {
                cacheLifecycles: e
              }), f ? g.createElement(f, t) : O(s || h, void 0, t);
            });
          });
        };

        return b && t && (l.cache[a + i] = {
          updateTime: Date.now(),
          pathname: a,
          search: i,
          render: e
        }, Object.entries(l.cache).sort(function (e, t) {
          e = S(e, 2)[1];
          return S(t, 2)[1].updateTime - e.updateTime;
        }).forEach(function (e, t) {
          e = S(e, 1)[0];
          n <= t && delete l.cache[e];
        })), b ? g.createElement(w.Fragment, null, Object.entries(l.cache).map(function (e) {
          var t = S(e, 2),
              n = t[0],
              e = t[1],
              t = e.render,
              e = e.pathname;
          return g.createElement(w.Fragment, {
            key: n
          }, t(R({}, r, u, {
            pathname: e,
            cacheKey: y,
            multiple: !0,
            key: e,
            match: n === a + i ? o || c : null
          })));
        })) : e(R({}, r, u, {
          pathname: a,
          multiple: !1
        }));
      });
    }
  }]), ie);

  function ie() {
    var e;
    l(this, ie);

    for (var t = arguments.length, n = Array(t), r = 0; r < t; r++) {
      n[r] = arguments[r];
    }

    return (e = b(this, (e = ie.__proto__ || Object.getPrototypeOf(ie)).call.apply(e, [this].concat(n)))).cache = {}, b(e, e);
  }

  t.__name = "CacheRoute", t.propTypes = {
    component: n.elementType || n.any,
    render: n.func,
    children: n.oneOfType([n.func, n.node]),
    computedMatchForCacheRoute: n.object,
    multiple: n.oneOfType([n.bool, n.number])
  }, t.defaultProps = {
    multiple: !1
  };
  var ue = r(w.Fragment) ? function (e) {
    e = e.children;
    return g.createElement(w.Fragment, null, e);
  } : r(w.PropTypes) ? function (e) {
    e = e.children;
    return g.createElement("div", null, e);
  } : function (e) {
    return e.children;
  };
  ue.displayName = "SwitchFragment";
  var le,
      he = r(i.__RouterContext) || r(i.useHistory),
      m = (le = i.Switch, _(se, le), m(se, [{
    key: "render",
    value: function value() {
      var e = this.props,
          t = e.children,
          r = e.which,
          e = this.getContext(),
          o = e.location,
          c = e.match,
          a = !1;
      return g.createElement(oe, {
        when: Z(c)
      }, function () {
        return g.createElement(ue, null, g.Children.map(t, function (e) {
          if (!g.isValidElement(e)) return null;
          var t = e.props.path || e.props.from,
              n = a ? null : t ? i.matchPath(o.pathname, R({}, e.props, {
            path: t
          }), c) : c,
              t = void 0,
              t = r(e) ? g.cloneElement(e, R({
            location: o,
            computedMatch: n
          }, u(n) ? {
            computedMatchForCacheRoute: v({}, Y, !0)
          } : null)) : n && !a ? g.cloneElement(e, {
            location: o,
            computedMatch: n
          }) : null;
          return a = a || !!n, t;
        }));
      });
    }
  }]), se);

  function se() {
    var e, t;
    l(this, se);

    for (var n = arguments.length, r = Array(n), o = 0; o < n; o++) {
      r[o] = arguments[o];
    }

    return (t = b(this, (e = se.__proto__ || Object.getPrototypeOf(se)).call.apply(e, [this].concat(r)))).getContext = function () {
      if (he) {
        var e = t.props;
        return {
          location: e.location,
          match: e.match
        };
      }

      e = t.context.router.route;
      return {
        location: t.props.location || e.location,
        match: e.match
      };
    }, b(t, t);
  }

  he ? (m.propTypes = {
    children: n.node,
    location: n.object.isRequired,
    match: n.object.isRequired,
    which: n.func
  }, m = i.withRouter(m)) : (m.contextTypes = {
    router: n.shape({
      route: n.object.isRequired
    }).isRequired
  }, m.propTypes = {
    children: n.node,
    location: n.object,
    which: n.func
  }), m.defaultProps = {
    which: function which(e) {
      return "CacheRoute" === f(e, "type.__name");
    }
  };
  e.default = t, e.CacheRoute = t, e.CacheSwitch = m, e.dropByCacheKey = B, e.refreshByCacheKey = function (e) {
    e = f(H, [e]);
    e && (e instanceof $ ? z(e) : Object.values(e).forEach(z));
  }, e.getCachingKeys = function () {
    return D().map(function (e) {
      return S(e, 1)[0];
    });
  }, e.clearCache = function () {
    D().forEach(function (e) {
      e = S(e, 1)[0];
      return B(e);
    });
  }, e.getCachingComponents = function () {
    return D().reduce(function (e, t) {
      var t = S(t, 2),
          r = t[0],
          t = t[1];
      return R({}, e, t instanceof $ ? v({}, r, t) : Object.entries(t).reduce(function (e, t) {
        var n = S(t, 2),
            t = n[0],
            n = n[1];
        return R({}, e, v({}, r + "." + t, n));
      }, {}));
    }, {});
  }, e.useDidCache = G, e.useDidRecover = J, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});